export enum FilterTypeEnum {
    Word,
    PowerPoint,
    Excel,
    PDF,
    Email,
    AllFiles,
    Library,
    Folder,
    Teams,
    SharePoint,
    OneDrive
}